<template>
  <DynamicDialog />
  <ConfirmDialog class="max-w-[500px] text-center" />
  <Toast :position="toastPosition" />
  <MainLayout />
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import MainLayout from './layouts/MainLayout.vue'
import { useToast } from 'primevue/usetoast'
import { useToastStore } from './shared/stores/useToastStore'
import { useAuthenticationStore } from './features/authentication/presentation/stores/useAuthenticationStore'

const authenticationStore = useAuthenticationStore()

const toastStore = useToastStore()
const toast = useToast()
const toastPosition = ref<
  | 'top-right'
  | 'top-left'
  | 'top-center'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right'
  | 'center'
>('top-right')

onMounted(() => {
  authenticationStore.setAuthenticationData()
})
watch(
  () => toastStore.toastData.index,
  () => {
    toast.add({
      severity: toastStore.toastData.severity,
      summary: toastStore.toastData.summary,
      detail: toastStore.toastData.detail,
      life: 6000
    })
    toastPosition.value = toastStore.toastData.position ?? 'top-right'
  },
  {
    immediate: true,
    deep: true
  }
)
</script>
